/**
 * @file
 *
 * Initializes shared Air Datepicker fields used by News search and submission forms.
 */

import $ from 'jquery';
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';

const searchDatepickers = {};
const submissionDatepickerSelectors = [
	'#article-publish-date',
	'#article-hidden-date',
	'#wantad-publish-date',
	'#wantad-hidden-date',
];

/**
 * Dispatch the change event expected by the existing form behavior.
 *
 * @param {HTMLInputElement} input Datepicker input.
 * @param {string} formattedDate Formatted date supplied by Air Datepicker.
 */
function updateInput(input, formattedDate) {
	input.value = formattedDate;
	$(input).trigger('change');
}

/**
 * Validate that the search end date is not earlier than its start date.
 */
function validateSearchDateRange() {
	const afterDate = searchDatepickers.after?.selectedDates[0];
	const beforeDate = searchDatepickers.before?.selectedDates[0];
	const rangeIsInvalid = afterDate && beforeDate && afterDate.getTime() > beforeDate.getTime();

	$('#search-date-before, #search-date-after').toggleClass('is-invalid', Boolean(rangeIsInvalid));
	$('#search-validation-message').toggle(Boolean(rangeIsInvalid));
	$('.search-form--submit').prop('disabled', Boolean(rangeIsInvalid));
}

/**
 * Initialize the date range fields shared by article search and dashboard filters.
 */
function initializeSearchDatepickers() {
	const fields = {
		after: document.querySelector('#search-date-after'),
		before: document.querySelector('#search-date-before'),
	};

	Object.entries(fields).forEach(([name, input]) => {
		if (!input) {
			return;
		}

		searchDatepickers[name] = new AirDatepicker(input, {
			locale: localeEn,
			autoClose: true,
			buttons: ['clear'],
			onSelect: ({ formattedDate }) => updateInput(input, formattedDate),
		});

		$(input).on('change keyup', validateSearchDateRange);
	});
}

/**
 * Initialize a submission date and time field when it exists on the page.
 *
 * @param {string} selector Input selector.
 */
function initializeSubmissionDatepicker(selector) {
	const input = document.querySelector(selector);

	if (!input) {
		return;
	}

	const datepicker = new AirDatepicker(input, {
		locale: localeEn,
		autoClose: true,
		dateFormat: 'MM/dd/yyyy',
		timeFormat: 'hh:mm aa',
		buttons: ['clear'],
		timepicker: true,
		hoursStep: 1,
		minutesStep: 1,
		onSelect: ({ formattedDate }) => updateInput(input, formattedDate),
	});

	if ($('#front-end-submit[data-screen="edit"]').length && input.value) {
		datepicker.selectDate(new Date(input.value));
	}
}

$(function() {
	initializeSearchDatepickers();
	submissionDatepickerSelectors.forEach(initializeSubmissionDatepicker);
});
